import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./Date.css";
import {
  addFilters,
  // applyFilters,
} from "../../store/slices/FilterSliceComplaint";
import { useQuery } from "@tanstack/react-query";
import {
  fetchRegion,
  fetchStates,
  fetchStatesOffice,
  fetchDealer,
  fetchDealercode,
  fetchDivision,
  fetchProductLine,
  fetchLOB,
  fetchOriginPoint,
  fetchAssignedUser,
  reducer,
} from "./apiComplaintFilter";
import MultipleSelectDropdown from "../Multi-Select-Dropdown/MultipleSelectDropdown";
import { applyFilters } from "../../store/slices/FilterSliceComplaint";

//*------------------COMP----------------------*//
export default function ComplaintFilter({ isFormVisible, setFormVisible }) {
  const { data, submitted } = useSelector((state) => state.filtersComplaint);
  // console.log(data, "dataaaa");

  const { data: newdata } = useSelector((state) => state.forms);

  const {
    region: pRegion,
    state: pState,
    state_office: pStateOffice,
    dealer_name: pDealer,
    dealer_code: pDealerCode,
    division_name: pDivision,
    Product_Line: pProductLine,
    lob: pLob,
    origin_point: pOriginPoint,
    employee_name: pEmployeeName,
  } = data;

  // console.log(pRegion, "region");
  // console.log(pState, "state");
  // console.log(pStateOffice, "sso");
  // console.log(pDealer, "dealer");
  // console.log(pDealerCode, "dcode");
  // console.log(pDivision, "division");
  // console.log(pProductLine, "pl");
  // console.log(pLob, "lob");
  // console.log(pOriginPoint, "origin");
  // console.log(pEmployeeName, "employee");

  const dispatch = useDispatch();
  const [clicked, setClicked] = useState(1);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedStateOffice, setSelectedStateOffice] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState([]);
  const [selectedDealerCode, setSelectedDealerCode] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState([]);
  const [selectedProductLine, setSelectedProductLine] = useState([]);
  const [selectedLob, setSelectedLOB] = useState([]);
  const [selectedOrigin, setSelectedOrigin] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);

  // const [isFormVisible, setFormVisible] = useState(false);
  //* ---------------USE QUERY---------------------/

  const { data: regions, isLoading: rL } = useQuery({
    queryKey: ["region", submitted],
    queryFn: () => fetchRegion(),
    initialData: [],
  });

  const { data: states, isLoading: sL } = useQuery({
    queryKey: ["states", submitted, pRegion],
    queryFn: () => fetchStates(pRegion),
    initialData: [],
  });

  const { data: statesoffice, isLoading: soL } = useQuery({
    queryKey: ["statesoffice", submitted, pRegion, pState],
    queryFn: () => fetchStatesOffice(pRegion, pState),
    initialData: [],
  });
  const { data: division, isLoading: diL } = useQuery({
    queryKey: ["division", submitted, pRegion, pState, pStateOffice],
    queryFn: () => fetchDivision(pRegion, pState, pStateOffice),
    initialData: [],
  });

  const { data: dealer, isLoading: dL } = useQuery({
    queryKey: ["dealer", submitted, pRegion, pState, pStateOffice, pDivision],
    queryFn: () => fetchDealer(pRegion, pState, pStateOffice, pDivision),
    initialData: [],
  });

  const { data: dealercode, isLoading: dcL } = useQuery({
    queryKey: [
      "dealercode",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDivision,
      pDealer,
    ],
    queryFn: () =>
      fetchDealercode(pRegion, pState, pStateOffice, pDivision, pDealer),
    initialData: [],
  });

  const { data: productLine, isLoading: plL } = useQuery({
    queryKey: [
      "productLine",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
      pDivision,
    ],
    queryFn: () =>
      fetchProductLine(
        pRegion,
        pState,
        pStateOffice,
        pDealer,
        pDealerCode,
        pDivision
      ),
    initialData: [],
  });

  const { data: lob, isLoading: lobL } = useQuery({
    queryKey: [
      "lob",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
    ],
    queryFn: () =>
      fetchLOB(
        pRegion,
        pState,
        pStateOffice,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine,
        pOriginPoint,
        pEmployeeName
      ),
    initialData: [],
  });
  const { data: origin, isLoading: op } = useQuery({
    queryKey: [
      "origin",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
      pLob,
      pOriginPoint,
      pEmployeeName,
    ],
    queryFn: () =>
      fetchOriginPoint(
        pRegion,
        pState,
        pStateOffice,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine,
        pLob,
        pOriginPoint,
        pEmployeeName
      ),
    initialData: [],
  });

  const { data: employee, isLoading: en } = useQuery({
    queryKey: [
      "employee",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
      pLob,
      pOriginPoint,
      pEmployeeName,
    ],
    queryFn: () =>
      fetchAssignedUser(
        pRegion,
        pState,
        pStateOffice,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine,
        pLob,
        pOriginPoint,
        pEmployeeName
      ),
    initialData: [],
  });

  //* ---------------HANDLE EVENTS---------------------/
  async function handleSearch() {
    let userSelectedFilter = {
      data: {
        region: pRegion || selectedRegion,
        state: pState || selectedState,
        state_office: pStateOffice || selectedStateOffice,
        dealer_name: pDealer || selectedDealer,
        dealer_code: pDealerCode || selectedDealerCode,
        division_name: pDivision || selectedDivision,
        Product_Line: pProductLine || selectedProductLine,
        lob: pLob || selectedLob,
        origin_point: pOriginPoint || selectedOrigin,
        employee_name: pEmployeeName || selectedEmployee,
      },
      submitted: clicked + 1,
    };

    // console.log(data, "after apply");
    dispatch(addFilters(userSelectedFilter));
    setClicked((prev) => prev + 1);
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  const toggleForm = () => {
    setFormVisible(!isFormVisible);
  };

  //*----------------------JSX-------------------------/
  return (
    // <section className="grid grid-cols-2 gap-2 p-2 border-[#2c8a8b] border rounded-md md:gap-2 lg:grid-cols-[repeat(13,minmax(0,1fr))] md:grid-cols-4">
    <section className="">
      {isFormVisible && (
        <div className="border-[#2c8a8b] border rounded-md  grid grid-cols-2 gap-2 p-2 md:gap-2 lg:grid-cols-[repeat(12,minmax(0,1fr))] md:grid-cols-4">
          <div className={divStyle}>
            <label className={labelStyle}>Region</label>
            <MultipleSelectDropdown
              options={regions}
              onSelectionChange={setSelectedRegion}
              opnsSelected={pRegion}
              keey="region"
              isLoading={rL}
              applyFilters={applyFilters}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>State</label>
            <MultipleSelectDropdown
              options={states}
              onSelectionChange={setSelectedState}
              opnsSelected={pState}
              keey="state"
              isLoading={sL}
              applyFilters={applyFilters}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>SSO</label>
            <MultipleSelectDropdown
              options={statesoffice}
              onSelectionChange={setSelectedStateOffice}
              opnsSelected={pStateOffice}
              keey="state_office"
              applyFilters={applyFilters}
              isLoading={soL}
            />
          </div>
          <div className={divStyle}>
            <label className={labelStyle}>Division</label>
            <MultipleSelectDropdown
              options={division}
              onSelectionChange={setSelectedDivision}
              opnsSelected={pDivision}
              keey="division_name"
              applyFilters={applyFilters}
              isLoading={diL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>Dealer Name</label>
            <MultipleSelectDropdown
              options={dealer}
              onSelectionChange={setSelectedDealer}
              opnsSelected={pDealer}
              keey="dealer_name"
              applyFilters={applyFilters}
              isLoading={dL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>Dealer Code</label>
            <MultipleSelectDropdown
              options={dealercode}
              onSelectionChange={setSelectedDealerCode}
              opnsSelected={pDealerCode}
              keey="dealer_code"
              applyFilters={applyFilters}
              isLoading={dcL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>Product Line</label>
            <MultipleSelectDropdown
              options={productLine}
              onSelectionChange={setSelectedProductLine}
              opnsSelected={pProductLine}
              keey="Product_Line"
              applyFilters={applyFilters}
              isLoading={plL}
            />
          </div>

          <div className={divStyle}>
            <label className={labelStyle}>LOB</label>
            <MultipleSelectDropdown
              options={lob}
              onSelectionChange={setSelectedLOB}
              opnsSelected={pLob}
              keey="lob"
              applyFilters={applyFilters}
              isLoading={lobL}
            />
          </div>
          <div className={divStyle}>
            <label className={labelStyle}>Origin Point</label>
            <MultipleSelectDropdown
              options={origin}
              onSelectionChange={setSelectedOrigin}
              opnsSelected={pOriginPoint}
              keey="origin_point"
              applyFilters={applyFilters}
              isLoading={op}
            />
          </div>
          <div className={divStyle}>
            <label className={labelStyle}>Assigned to User</label>
            <MultipleSelectDropdown
              options={employee}
              onSelectionChange={setSelectedEmployee}
              opnsSelected={pEmployeeName}
              keey="employee_name"
              applyFilters={applyFilters}
              isLoading={en}
            />
          </div>
          <div className="flex flex-col justify-end">
            <button
              className=" text-white w-full rounded-sm  bg-[#2A5775] "
              type="button"
              onClick={handleSearch}
            >
              Apply
            </button>
          </div>
          <div className="flex flex-col justify-end">
            <button
              className=" text-white bg-[#2A5775] rounded-sm w-full"
              onClick={handleRefresh}
            >
              Reset
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

//*------------------CSS----------------------*//
const divStyle = "flex flex-col justify-center";
const labelStyle = "font-semibold py-1 text-xs text-[#2A5775]";

// ==================================================================================
